export default "__VITE_ASSET__CkzTB55n__"